import { app } from '../../bootstrap/core';
import { resetPasswordState } from './resetPassword.state';
import { resetPasswordComponent } from './resetPassword.component';

app.config(resetPasswordState);
app.component(resetPasswordComponent.name, resetPasswordComponent);
